import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useBem from '@indicia/use-bem';

import SurveyQuestionType from '../../../../shared/models/survey/SurveyQuestionType';
import useSurveyContext from '../../store/UseSurveyContext';

import './SurveyProgress.scss';

type SurveyProgressType = {
  currentQuestion: number;
  totalQuestions: number;
};

const SurveyProgress = ({ currentQuestion, totalQuestions }: SurveyProgressType) => {
  const { bemClassName, bemClassNames } = useBem('survey-progress');
  const [progress, setProgress] = useState<number>();
  const [percentage, setPercentage] = useState<number>();
  const { survey } = useSurveyContext();
  const { t } = useTranslation();

  const getCurrentChapterIndex = (questionNumber: number, chapters: number[]): number => {
    for (let i = chapters.length - 1; i >= 0; i -= 1) {
      if (questionNumber > chapters[i]) {
        return i;
      }
    }
    return -1;
  };

  useEffect(() => {
    if (survey) {
      const chapterIndexes = [];

      for (let i = 0; i < survey!.questions.length; i += 1) {
        const surveyType = survey!.questions[i].questionType;
        if (surveyType === SurveyQuestionType.CHAPTER_INTRODUCTION || surveyType === SurveyQuestionType.INTRODUCTION) {
          chapterIndexes.push(i);
        }
      }

      const currentChapterIndex = getCurrentChapterIndex(currentQuestion, chapterIndexes);
      let newProgress = 0;
      if (currentQuestion > 0) {
        newProgress = currentQuestion - currentChapterIndex;
      }

      setProgress(newProgress);
      setPercentage(Math.round((newProgress / totalQuestions) * 100));
    }
  }, [survey, currentQuestion]);

  return (
    <div className={bemClassName()}>
      <div className={bemClassName('bar')}>
        <div
          className={bemClassName('progress')}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className={bemClassName('labels')}>
        <div className={bemClassNames([bemClassName('label'), bemClassName('label', 'current')])}>
          {t('survey.current', { progress })}
        </div>
        <div
          className={bemClassNames([
            bemClassName('label'),
            bemClassName('label', 'percentage'),
            bemClassName('label', 'completed', percentage === 100),
          ])}
        >
          {t('survey.percentage', { percentage })}
        </div>
      </div>
    </div>
  );
};

export default SurveyProgress;
